import { render, staticRenderFns } from "./Desperta.vue?vue&type=template&id=203eb043&scoped=true"
import script from "./Desperta.vue?vue&type=script&lang=js"
export * from "./Desperta.vue?vue&type=script&lang=js"
import style0 from "./Desperta.vue?vue&type=style&index=0&id=203eb043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203eb043",
  null
  
)

export default component.exports